<template>
  <div>
    <list row-key="id" ref="list" unit="发货地址" :page="page" :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus">新建发货地址</el-button>
      </template>
      <template slot="table">
        <el-table-column prop="sendGoodsContactor" label="寄件人" width="140px" />
        <el-table-column label="手机号码/固定号码" width="240px">
          <template slot-scope="{row}">
            <div>
              <span>{{ row.mobile }}</span>
              <span style="margin: 0 5px;" v-if="row.mobile && row.phone">/</span>
              <span>{{ row.phone }}</span>
            </div>
            <!-- <div class="tip" v-if="row.手机号码脱敏">打印时脱敏显示</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="物流公司" min-width="300px" />
        <el-table-column label="发货地址" min-width="300px">
          <template slot-scope="{row}">
            <span>{{ row.fullAddress.replaceAll("^^^", "") }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="所属店铺" label="所属店铺" min-width="200px">
          <template slot-socpe="{row}">大龙猫杂货店</template>
        </el-table-column> -->
        <el-table-column label="操作" width="250px" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button type="primary" @click="edit(row)">编辑</el-button>
            <el-button type="danger" @click="onDelete(row)" :disabled="row.isDefault">删除</el-button>
            <el-button type="success" @click="setDefault(row)" :disabled="row.isDefault">设为默认</el-button>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import editDialog from "./editDialog"

export default {
  mixins: [listMixin],
  components: { list, editDialog },
  data() {
    return {
      aliApi: {
        logistics: require('@/api/ali/logistics').default,
      },
      sysType: "",
      mallToken: "", //店铺Token
    };
  },
  created() {
    this.sysType = "ali"; //localStorage.getItem("sys_type");
    this.mallToken = localStorage.getItem("token");
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.getSendaddress(params).then(res => {
          console.log("res", res)
          resolve({ code: 0, data: res.data, count: res.count })
        }).catch(err => {
          resolve({ code: 1, data: [] })
        })
      })
    },
    create() {
      if (this.$refs.list.loading) {
        this.$message.warning("列表加载中，请稍候");
        return;
      }
      this.$refs.editDialog.openCreate()
    },
    edit(data) {
      this.$refs.editDialog.openEdit(JSON.parse(JSON.stringify(data)))
    },
    setDefault(data) {
      console.log("setDefault", data)
      this[this.sysType + "Api"].logistics.setDefault(data.id).then(res => {
        this.$message.success("设置成功");
        this.reload();
      }).catch(err => { })
    },
    onDelete(data) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this[this.sysType + "Api"].logistics.delSendaddress({ ids: [data.id] }).then(res => {
          if (res) {
            this.$message.error(res.errorMessage);
          } else {
            this.$message.success("删除成功");
            this.reload();
          }
        }).catch(err => { })
      }).catch(() => { });
    },
  },
};
</script>